/* Pop-ups wait until the visitor has engaged with the page. */
(() => {
  const root = document.documentElement;
  const storageKey = 'enzoPopupsReady';
  let done = false;
  let timer;
  function show() {
    if (done) return;
    done = true;
    clearTimeout(timer);
    removeEventListener('scroll', onScroll);
    root.classList.add('enzo-popups-ready');
    try { sessionStorage.setItem(storageKey, '1'); } catch (error) {}
  }
  function onScroll() {
    const max = root.scrollHeight - innerHeight;
    if (max > 0 && scrollY / max > 0.4) show();
  }
  let seen = false;
  try { seen = sessionStorage.getItem(storageKey) === '1'; } catch (error) {}
  if (seen || (window.Shopify && window.Shopify.designMode)) { show(); return; }
  addEventListener('scroll', onScroll, { passive: true });
  timer = setTimeout(show, 25000);
})();

/* Wishlist (saved in this browser) and quick add to cart. */
(() => {
  const KEY = 'enzoWishlist';
  const shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const STRINGS = {
    it: { add: 'Aggiungi ai preferiti', remove: 'Rimuovi dai preferiti', saved: 'Nei preferiti', title: 'I tuoi preferiti', empty: 'Non hai ancora salvato prodotti. Tocca il cuore su un prodotto per ritrovarlo qui.', note: 'I preferiti restano salvati su questo dispositivo.', close: 'Chiudi', cart: 'Aggiungi al carrello' },
    en: { add: 'Add to wishlist', remove: 'Remove from wishlist', saved: 'Saved', title: 'Your wishlist', empty: 'No saved products yet. Tap the heart on a product to find it here.', note: 'Your wishlist is saved on this device.', close: 'Close', cart: 'Add to cart' },
    de: { add: 'Zur Wunschliste', remove: 'Von der Wunschliste entfernen', saved: 'Gemerkt', title: 'Deine Wunschliste', empty: 'Noch keine Produkte gemerkt. Tippe auf das Herz, um sie hier zu finden.', note: 'Die Wunschliste wird auf diesem Gerät gespeichert.', close: 'Schließen', cart: 'In den Warenkorb' },
    fr: { add: 'Ajouter aux favoris', remove: 'Retirer des favoris', saved: 'Dans les favoris', title: 'Vos favoris', empty: 'Aucun produit enregistré. Touchez le cœur d’un produit pour le retrouver ici.', note: 'Vos favoris sont enregistrés sur cet appareil.', close: 'Fermer', cart: 'Ajouter au panier' },
    es: { add: 'Añadir a favoritos', remove: 'Quitar de favoritos', saved: 'En favoritos', title: 'Tus favoritos', empty: 'Aún no has guardado productos. Toca el corazón de un producto para encontrarlo aquí.', note: 'Tus favoritos se guardan en este dispositivo.', close: 'Cerrar', cart: 'Añadir al carrito' },
    pt: { add: 'Adicionar aos favoritos', remove: 'Remover dos favoritos', saved: 'Nos favoritos', title: 'Os seus favoritos', empty: 'Ainda não guardou produtos. Toque no coração de um produto para o encontrar aqui.', note: 'Os favoritos ficam guardados neste dispositivo.', close: 'Fechar', cart: 'Adicionar ao carrinho' }
  };
  const t = STRINGS[(document.documentElement.lang || 'it').slice(0, 2)] || STRINGS.it;
  const svg = paths => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${paths}</svg>`;
  const ICONS = {
    heart: svg('<path class="enzo-heart-path" d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/>'),
    bag: svg('<path d="M5.5 8.5h13l-1 11.5h-11z"/><path d="M9 8.5V7a3 3 0 0 1 6 0v1.5"/>'),
    check: svg('<path d="m5 12.5 4.5 4.5L19 7.5"/>'),
    close: svg('<path d="M6 6l12 12M18 6 6 18"/>')
  };
  const QUICK_SCOPE = '.template--index .section--featured-products card-product, .enzo-spot card-product';

  function read() {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value.filter(item => typeof item === 'string') : [];
    } catch (error) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 60))); } catch (error) {}
  }
  function toggle(handle) {
    const list = read();
    write(list.includes(handle) ? list.filter(item => item !== handle) : [handle, ...list]);
    sync();
  }

  /* Updates hearts and the header counter only (never re-renders the panel). */
  function updateButtons() {
    const list = read();
    document.querySelectorAll('[data-enzo-wish]').forEach(button => {
      const on = list.includes(button.dataset.enzoWish);
      const pressed = on ? 'true' : 'false';
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
      const label = `${on ? t.remove : t.add}${button.dataset.title ? ': ' + button.dataset.title : ''}`;
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      const text = button.querySelector('.enzo-wish__label');
      if (text && text.textContent !== (on ? t.saved : t.add)) text.textContent = on ? t.saved : t.add;
    });
    document.querySelectorAll('.enzo-wish-count').forEach(count => {
      if (count.textContent !== String(list.length)) count.textContent = list.length;
      count.hidden = list.length === 0;
    });
  }
  /* After the list changes: update buttons and, if open, the panel. */
  function sync() {
    updateButtons();
    if (dialog && dialog.open) render();
  }

  function wishButton(handle, title, inline) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = inline ? 'enzo-wish enzo-wish--inline' : 'enzo-card-btn enzo-wish';
    button.dataset.enzoWish = handle;
    if (title) button.dataset.title = title;
    button.innerHTML = ICONS.heart + (inline ? `<span class="enzo-wish__label">${t.add}</span>` : '');
    return button;
  }

  /* Header heart: built like the theme's own header icons (same link classes, 1em size,
     same stroke width and line joins as the cart icon), so it matches them exactly. */
  function headerButton() {
    if (document.querySelector('.enzo-wish-header')) return;
    const cartLink = document.querySelector('[data-cart-link]');
    if (!cartLink) return;
    const item = cartLink.closest('.header__utils-item') || cartLink.parentElement;
    const ref = cartLink.querySelector('svg path');
    const strokeWidth = (ref && ref.getAttribute('stroke-width')) || '1.5';
    const strokeJoin = (ref && ref.getAttribute('stroke-linejoin')) || 'round';
    const wrapper = document.createElement(item.tagName === 'LI' ? 'li' : 'div');
    wrapper.className = `${(item.className || '').replace('header__utils-item--cart', '')} enzo-wish-header`.trim();
    wrapper.innerHTML = `<a href="#" role="button" class="header__utils-link svg-color-inherit enzo-wish-open" aria-haspopup="dialog" aria-label="${t.title}" title="${t.title}"><svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M12 20.5S3.5 15.6 3.5 9.4A4.4 4.4 0 0 1 12 7.1a4.4 4.4 0 0 1 8.5 2.3c0 6.2-8.5 11.1-8.5 11.1z" stroke="currentColor" stroke-width="${strokeWidth}" stroke-linejoin="${strokeJoin}" data-ignore-fill/></svg><span class="enzo-wish-count" hidden>0</span></a>`;
    wrapper.querySelector('a').addEventListener('keydown', event => { if (event.key === ' ') { event.preventDefault(); openDialog(); } });
    item.before(wrapper);
  }

  function enhance() {
    let added = false;
    document.querySelectorAll('card-product[data-handle]').forEach(card => {
      if (card.dataset.enzoActions) return;
      const holder = card.querySelector(':scope > .relative');
      if (!holder) return;
      card.dataset.enzoActions = '1';
      added = true;
      const title = ((card.querySelector('.card-product__title') || {}).textContent || '').trim();
      const actions = document.createElement('div');
      actions.className = 'enzo-card-actions';
      actions.append(wishButton(card.dataset.handle, title));
      if (card.matches(QUICK_SCOPE)) {
        const cart = document.createElement('button');
        cart.type = 'button';
        cart.className = 'enzo-card-btn enzo-quick-add';
        cart.dataset.handle = card.dataset.handle;
        cart.innerHTML = ICONS.bag;
        cart.setAttribute('aria-label', `${t.cart}: ${title}`);
        actions.append(cart);
      }
      holder.append(actions);
    });
    if (document.body.classList.contains('template--product') && !document.querySelector('.enzo-wish--inline')) {
      const heading = document.querySelector('.product__title');
      const match = location.pathname.match(/\/products\/([^/?#]+)/);
      if (heading && match) { heading.insertAdjacentElement('afterend', wishButton(decodeURIComponent(match[1]), heading.textContent.trim(), true)); added = true; }
    }
    headerButton();
    if (added) updateButtons();
  }

  const products = new Map();
  function getProduct(handle) {
    if (!products.has(handle)) {
      products.set(handle, fetch(`${shopRoot}products/${encodeURIComponent(handle)}.js`).then(response => response.ok ? response.json() : null).catch(() => null));
    }
    return products.get(handle);
  }
  function money(cents) {
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'it', { style: 'currency', currency }).format(cents / 100); }
    catch (error) { return (cents / 100).toFixed(2); }
  }

  let dialog;
  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'enzo-wish-dialog';
    dialog.setAttribute('aria-labelledby', 'EnzoWishTitle');
    dialog.innerHTML = `<div class="enzo-wish-dialog__head"><h2 id="EnzoWishTitle">${t.title}</h2><button type="button" class="enzo-wish-dialog__close" aria-label="${t.close}">${ICONS.close}</button></div><div class="enzo-wish-dialog__body"></div><p class="enzo-wish-dialog__note">${t.note}</p>`;
    document.body.append(dialog);
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    return dialog;
  }
  let renderId = 0;
  async function render() {
    const id = ++renderId;
    const body = dialog.querySelector('.enzo-wish-dialog__body');
    const list = read();
    if (!list.length) { body.innerHTML = `<p class="enzo-wish-empty">${t.empty}</p>`; return; }
    const items = await Promise.all(list.map(getProduct));
    if (id !== renderId) return;
    const ul = document.createElement('ul');
    ul.className = 'enzo-wish-list';
    items.forEach(product => {
      if (!product) return;
      const url = `${shopRoot}products/${encodeURIComponent(product.handle)}`;
      const li = document.createElement('li');
      li.className = 'enzo-wish-item';
      const image = product.featured_image ? `<img src="${product.featured_image}${product.featured_image.includes('?') ? '&' : '?'}width=200" alt="" width="72" height="72" loading="lazy">` : '';
      li.innerHTML = `<a class="enzo-wish-item__media" href="${url}">${image}</a><div class="enzo-wish-item__info"><p class="enzo-wish-item__vendor"></p><a class="enzo-wish-item__title" href="${url}"></a><p class="enzo-wish-item__price">${money(product.price)}</p></div><div class="enzo-wish-item__actions"></div>`;
      li.querySelector('.enzo-wish-item__vendor').textContent = product.vendor || '';
      li.querySelector('.enzo-wish-item__title').textContent = product.title;
      const actions = li.querySelector('.enzo-wish-item__actions');
      if (product.available) {
        const cart = document.createElement('button');
        cart.type = 'button';
        cart.className = 'enzo-card-btn enzo-quick-add';
        cart.dataset.handle = product.handle;
        cart.innerHTML = ICONS.bag;
        cart.setAttribute('aria-label', `${t.cart}: ${product.title}`);
        actions.append(cart);
      }
      actions.append(wishButton(product.handle, product.title));
      ul.append(li);
    });
    body.replaceChildren(ul);
    updateButtons();
  }
  function openDialog() {
    ensureDialog();
    render();
    dialog.showModal();
  }

  async function quickAdd(button) {
    const handle = button.dataset.handle;
    const url = `${shopRoot}products/${encodeURIComponent(handle)}`;
    button.setAttribute('aria-busy', 'true');
    let added = false;
    try {
      const product = await getProduct(handle);
      if (!product) throw new Error('product');
      const available = product.variants.filter(variant => variant.available);
      if (product.variants.length !== 1 || available.length !== 1) { location.href = url; return; }
      const response = await fetch(`${shopRoot}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: available[0].id, quantity: 1 }], sections: 'cart-counter,cart-drawer', sections_url: location.pathname })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error('cart');
      added = true;
      button.classList.add('is-added');
      button.innerHTML = ICONS.check;
      setTimeout(() => { button.classList.remove('is-added'); button.innerHTML = ICONS.bag; }, 1800);
      if (dialog && dialog.open) dialog.close();
      const drawer = document.querySelector('cart-drawer');
      try {
        if (!drawer || typeof drawer.renderContents !== 'function' || !cart.sections) throw new Error('drawer');
        drawer.classList.remove('is-empty');
        drawer.renderContents(cart);
      } catch (error) {
        location.href = `${shopRoot}cart`;
      }
    } catch (error) {
      if (!added) location.href = url;
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', event => {
    const wish = event.target.closest('[data-enzo-wish]');
    if (wish) { event.preventDefault(); event.stopPropagation(); toggle(wish.dataset.enzoWish); return; }
    const quick = event.target.closest('.enzo-quick-add');
    if (quick) { event.preventDefault(); event.stopPropagation(); quickAdd(quick); return; }
    if (event.target.closest('.enzo-wish-open')) { event.preventDefault(); openDialog(); return; }
    if (event.target.closest('.enzo-wish-dialog__close')) dialog.close();
  }, true);
  addEventListener('storage', event => { if (event.key === KEY) sync(); });

  let queued = false;
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; enhance(); });
  }
  function start() {
    enhance();
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(records => {
      if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && !node.classList.contains('enzo-card-actions') && !node.classList.contains('enzo-wish')))) queue();
    }).observe(main, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', queue);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
